export default {
  ECT_BUSH: 'bush',
  ECT_ROCK: 'rock',
}
